import template from './mobile_configuration.html';
import tr from '../../lib/default-translator.js';

class MobileConfigurationViewModel
{
	constructor(page)
	{
		this.page = page;
		this.images_list = ko.observableArray([]);
	}

	async add_image()
	{
		await Grape.dialog.open('MobileConfigurationAddImage', {});
		this.page.updateData();
	}

	show_help()
	{
		Grape.dialog.open('MobileConfigurationHelp', { 'employee_id': this.page.bindings.id });
	}
}

class MobileConfigurationPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new MobileConfigurationViewModel(this);
	}

	init()
	{
		document.title = tr('Mobile Configuration');
		window.current_page_title(tr('Mobile Configuration'));
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/mobile/list_mobile_images', {});
		this.viewModel.images_list(res || []);
	}
}

export default {
	route: '[/]admin/mobile_configuration',
	page_class: MobileConfigurationPage,
	template: template,
	template_filename: 'translation/mobile_configuration'
};
